import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsShellMessages = defineMessages("settings-shell", en);
